// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__16l4i","name":"ConsentHeader_name__2dRDx","birthday":"ConsentHeader_birthday___R6DT","skeleton":"ConsentHeader_skeleton__1uphm"};